import React from 'react';
import Svg, { Path } from 'react-native-svg';

const EyeIcon = ({size = 16 , color = '#1434CB'}: {size?: number, color?: string}) => (
  <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
    <Path
      d="M10 13.875c1.083 0 2-.375 2.75-1.125s1.125-1.667 1.125-2.75-.375-2-1.125-2.75S11.083 6.125 10 6.125 8 6.5 7.25 7.25 6.125 8.917 6.125 10s.375 2 1.125 2.75 1.667 1.125 2.75 1.125zm0 4.458a8.063 8.063 0 01-3.23-.656 8.452 8.452 0 01-2.655-1.792 8.452 8.452 0 01-1.792-2.656A8.063 8.063 0 011.667 10c0-1.153.218-2.236.656-3.25a8.328 8.328 0 011.792-2.646A8.543 8.543 0 016.77 2.323 8.063 8.063 0 0110 1.667c1.153 0 2.236.218 3.25.656a8.416 8.416 0 012.646 1.781 8.415 8.415 0 011.781 2.646 8.115 8.115 0 01.656 3.25 8.063 8.063 0 01-.656 3.23 8.541 8.541 0 01-1.781 2.655 8.328 8.328 0 01-2.646 1.792 8.115 8.115 0 01-3.25.656zm0-1.25c1.972 0 3.646-.69 5.02-2.073 1.376-1.381 2.063-3.052 2.063-5.01 0-1.972-.687-3.646-2.062-5.02C13.646 3.603 11.972 2.916 10 2.916c-1.958 0-3.628.687-5.01 2.062C3.608 6.354 2.917 8.028 2.917 10c0 1.958.69 3.629 2.073 5.01 1.382 1.382 3.052 2.073 5.01 2.073z"
      fill={color}
    />
  </Svg>
);

export default EyeIcon;
